import * as Effects from "redux-saga/effects";
import content from "../content";
import { ProjectActions } from "../reducers/project/actionsNames";
import { getAttributes } from "../reducers/project/selectors";

function* fetchContent(action) {
    const response = yield fetch(
        process.env.REACT_APP_API_URL + "/project/" + action.id,
        {
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
            },
        }
    );

    let project = yield response.json();

    yield Effects.put({
        type: ProjectActions.InsertSelectedAttributes,
        attributes: project.components,
    });
}

export default function* () {
    yield Effects.takeLatest(ProjectActions.FetchProject, fetchContent);
}
